import { RefObject } from "react";
import { openOtherUserPanel } from "../../../../../shared/User/OtherUserPanel/functions";

export function RankingRecordContainer({
    userId,
    children,
    cardRef,
}: {
    userId: number;
    children: JSX.Element;
    cardRef?: RefObject<HTMLDivElement>;
}) {
    return (
        <div
            ref={cardRef}
            onClick={() => {
                openOtherUserPanel(userId);
            }}
            className="hoverScale05 pointer"
        >
            {children}
        </div>
    );
}
